import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './ToggleForm.scss';

const defaultProps = {
  value: false,
  handleOnChange: () => {},
  cssClassName: '',
  disabled: false,
  onLabel: 'On',
  offLabel: 'Off',
};
const ToggleForm = (props) => {
  const {
    value,
    handleOnChange,
    cssClassName,
    disabled,
    onLabel,
    offLabel,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <ToggleButtonGroup {...rest} size='small' value={value} onChange={handleOnChange} exclusive className={`setting-toggle ${cssClassName}`}>
      <ToggleButton disabled={disabled} value>
        {onLabel}
      </ToggleButton>
      <ToggleButton disabled={disabled} value={false}>
        {offLabel}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ToggleForm;
